import { useCallback } from 'react'

import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $fanId, deleteChat } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { chatsService } from '@/modules/chatting/service/chats.ts'
import { handleError } from '@/utils/error'

export function useHideChat() {
  const creatorId = useUnit($creatorId)
  const toast = useToast()
  const fanId = useUnit($fanId)

  const hideChatMutation = useMutation(chatsService.hideChat, {
    onSuccess: () => {
      toast.success('Successfully hidden chat')
    },
    onSettled: (data, error, variables) => {
      if (!error) {
        deleteChat(variables.userId)
      }
    },
    onError: (error) => {
      handleError(
        error,
        'Unexpected error occurred while hiding chat, please try again later',
      )
    },
  })

  const handleHideChat = useCallback(async () => {
    if (fanId) {
      return hideChatMutation.mutateAsync({
        creatorId: creatorId!,
        userId: fanId,
      })
    }
  }, [fanId, creatorId, hideChatMutation])

  return {
    hideChat: handleHideChat,
    isHideChatLoading: hideChatMutation.isLoading,
  }
}
